import { YieldCalculatorStyleTokens } from "@/brand/productConfiguration/yieldCalculator/yieldCalculator.tokens";

export const YieldCalculatorStyles: YieldCalculatorStyleTokens = {
    submitButton: {
        color: "primary"
    }
};
